export const getExt = (fileName) => {
    const file = fileName.split('.').pop();
    if (!file)
        return;
    return file.toLowerCase();
};
export const isFileNamePhoto = (fileName) => {
    const ext = getExt(fileName);
    return ext === 'jpg' || ext === 'jpeg';
};
export const isFileNamePdf = (fileName) => {
    const ext = getExt(fileName);
    return ext === 'pdf';
};
